import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'paymentType',
    serviceName: 'auth',
    query: gql`
      query paymentType($ids: [String]) {
        paymentType(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
